module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAYAAAAehFoBAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAB0SURBVFiF7daxDYAwDAVRG7FOVghsQZ3JWAVYgVloMTsYfRGke72dS6qYAQAAoF+eHSy1bWY2Jcf381jnzOCQPNDMIn3Z7pTaotQWit0vXvgbBKsRrEawGsFqBKsRrPa74FG09xLt1QRH3Iu7S/7DAACgKw+5mw8Iv5dVtgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/img/img-text.png
// module id = EjJG
// module chunks = 0